// extracted by mini-css-extract-plugin
module.exports = {"primary":"style_primary__d_9Wv","secondary":"style_secondary__b5sp7","small":"style_small__8Uqb5","regular":"style_regular__IE6ls","large":"style_large__Q_5zn"};